import React, { useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import {
  Button,
  Field,
  Input,
  Modal,
  Select,
  StrokeIcon,
  Textarea,
} from "../../../components/ui";

const SentPrice = ({ fileId, price, setRefreshData }) => {
  const [newPrice, setNewPrice] = useState(price);
  const [feasible, setFeasible] = useState("POSSIBLE");
  const [notes, setNotes] = useState("");
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleFileChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const jsonData = {
        price: newPrice,
        feasible,
        notes,
      };

      const formData = new FormData();
      if (!attachment && feasible === "POSSIBLE") {
        alert("Attachment of the mod file is missing!");
        return;
      }
      formData.append("file", attachment);
      formData.append("jsonData", JSON.stringify(jsonData));

      await axiosInstance.put(`/files/${fileId}/feasible-and-price`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setRefreshData(true);
      setModal(false);
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button onClick={() => setModal(true)} className="w-full">
        <StrokeIcon className="h-5 w-5">
          <path d="M20 6 9 17l-5-5" />
        </StrokeIcon>
        Possible &amp; Price
      </Button>

      {modal && (
        <Modal
          title="Update Details"
          size="max-w-md"
          onClose={loading ? undefined : () => setModal(false)}
          footer={
            <>
              <Button
                variant="ghost"
                size="sm"
                disabled={loading}
                onClick={() => setModal(false)}
              >
                Cancel
              </Button>
              <Button size="sm" onClick={handleSubmit} disabled={loading}>
                {loading ? "Submitting…" : "Submit"}
              </Button>
            </>
          }
        >
          <div className="space-y-4">
            <Field label="Feasible">
              <Select value={feasible} onChange={(e) => setFeasible(e.target.value)}>
                <option value="POSSIBLE">POSSIBLE</option>
                <option value="NOT_POSSIBLE">NOT POSSIBLE</option>
              </Select>
            </Field>

            <Field label="Paid Price" hint="What the customer is charged, in CRS.">
              <Input
                type="number"
                value={newPrice}
                onChange={(e) => setNewPrice(Number(e.target.value))}
              />
            </Field>

            <Field label="Notes" hint="Shown on the customer's file page as IMPORTANT.">
              <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows="3" />
            </Field>

            <Field
              label="Attachment"
              hint={
                feasible === "POSSIBLE"
                  ? "The modified file — required when the job is possible."
                  : "Optional when the job is not possible."
              }
            >
              <input
                type="file"
                onChange={handleFileChange}
                required
                className="block w-full cursor-pointer rounded-[12px] border border-gray-300 bg-white text-sm text-gray-600 file:mr-3 file:cursor-pointer file:rounded-l-[10px] file:border-0 file:bg-gray-100 file:px-4 file:py-2.5 file:text-sm file:font-semibold file:text-gray-700 hover:border-red-400/60 dark:border-[#3a3a3d] dark:bg-[#262628] dark:text-slate-300 dark:file:bg-[#303032] dark:file:text-slate-200"
              />
            </Field>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default SentPrice;
